export const SampleDownloadModelData = function () {
  return {
    success: null
  }
}
